import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { functions, auth } from "../../firebase";
import styles from "./styles.module.css";

export default function BetaSignup() {
  const history = useHistory();
  const [active, setActive] = useState(false);
  const [name, setName] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [isRunning, setIsRunning] = useState(false);
  const [error, setError] = useState(false);
  const getInvite = functions.httpsCallable("verifySignup");

  useEffect(() => {
    try {
      const searchParams = window.location.href.split("?")[1];
      const params = new URLSearchParams(searchParams);
      const inviteID = params.get("invite");
      if (!inviteID) throw "invite is null";
      getInvite({ invite: inviteID })
      .then(invite => {
        const { name, email, active } = invite.data;
        setActive(active);
        setName(name);
        setEmail(email);
      })
      .catch(err => console.log(err));
    }
    catch (err) {
      console.log(err);
      alert("an error occured");
    }
  }, []);

  useEffect(() => {
    if (isRunning || email === "" || password === "") {
      setDisabled(true);
    }
    else {
      setDisabled(false);
    }
  }, [email, password, isRunning]);

  const signup = () => {
    setIsRunning(true);
    auth.createUserWithEmailAndPassword(email, password)
      .then(async userCredentials => {
        const user = userCredentials.user;
        const baseUrl = "https://us-central1-deft-cef16.cloudfunctions.net/signupWebhook";
        const url = encodeURI(`${baseUrl}?uid=${user.uid}&email=${email}&name=${name}`);
        try {
          await fetch(url, { mode: 'no-cors'});
          history.push("/home");
        }
        catch (err) {
          history.push("/auth/login", {error: err});
        }
      })
      .catch(error => {
        if (error.code === "auth/email-already-in-use") {
          setIsRunning(false);
          setError("Account with email already exists");
        }
        else setError(error);
      });
  }

  if (!active) return <div style={{textAlign: "center"}}>Your invite is not yet active</div>
  if (error) {
    return (
      <div className={styles.authContainer}>
        <div>{typeof error === "string" ? error : "An error occurred"}</div>
      </div>  
    )
  }
  return (
    <>
      <div 
        style={{
          textAlign: "center",
          fontSize: "2.6em",
          fontWeight: 600,
          marginBottom: "18px"
        }}
      >
        {name ? `Hello, ${name.split(" ")[0]} 👋` : null}
      </div>
      <div className={styles.authContainer}>
        <div className={styles.containerTitle}>Signup</div>
        <form>
        <div style={{ marginTop: 20 }}>
          <label htmlFor="email">Email</label>
          <input 
            className={"input"} 
            type="text" 
            name="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required
          />
        </div>
        <div style={{ marginTop: 20 }}>
          <label htmlFor="password">Password</label>
          <input 
            className={"input"} 
            type="password" 
            name="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required
          />
        </div>
        <div>
          <button 
            disabled={disabled}
            type="button" 
            className={styles.authButton} 
            onClick={signup}
          >
            {isRunning ? "Working on it" : "Signup"}
          </button>
        </div>
        </form>
      </div>
    </>
  )
}